import React from "react";
import ProfileLabeledInput from "./profile-labeled-input.js";
import ProfileDateInput from "./profile-date-input.js";
import {typesPermisPeche} from "../enums";

export default function ProfileChamps({
                                          texts,
                                          authToken,
                                          profile,
                                          errors,
                                          pays,
                                          provinces,
                                          showCalendrierDateNaissance,
                                          calIconDansChamp,
                                          onChangeProfilePropertyText,
                                          onChangeEmail,
                                          setProfileState,
                                          toggleCalendrierDateNaissance,
                                          onSelectDateNaissance,
                                          calendarDateNaissanceWrapperDivRef,
                                      }) {
    return (
        <>
            <ProfileLabeledInput label={ texts.nom } value={ profile.nom } onChange={ e => onChangeProfilePropertyText("nom", e.target.value, 40, true) } errors={ errors.nom }/>
            <ProfileLabeledInput label={ texts.prenom } value={ profile.prenom } onChange={ e => onChangeProfilePropertyText("prenom", e.target.value, 40, true) } errors={ errors.prenom }/>
            <div className="profile-div">
                <div className="profile-div profile-label-wrapper">
                    <span className="profile-span">{ texts.pays }</span>
                </div>
                <div className="profile-div input-container">
                    <select value={ profile.idPays } onChange={ e => setProfileState({...profile, idPays: e.target.value}) } className="profile-input">
                        { (pays || []).map(p => (
                            <option key={ p.idPays } value={ p.idPays }>
                                { p.description.toUpperCase() }
                            </option>
                        )) }
                    </select>
                    { errors.pays && <span className="color-error profile-span">{ errors.pays }</span> }
                </div>
            </div>
            <div className="profile-div">
                <div className="profile-div profile-label-wrapper">
                    <span className="profile-span">{ texts.province }</span>
                </div>
                <div className="profile-div input-container">
                    <select value={ profile.idProvince } onChange={ e => setProfileState({...profile, idProvince: e.target.value}) } className="profile-input">
                        { (provinces || []).filter(p => p.idPays === profile.idPays).map(province => (
                            <option key={ province.idProvince } value={ province.idProvince }>
                                { province.description.toUpperCase() }
                            </option>
                        )) }
                    </select>
                    { errors.province && <span className="color-error profile-span">{ errors.province }</span> }
                </div>
            </div>
            <ProfileLabeledInput label={ texts.adresse } value={ profile.adresse } onChange={ e => onChangeProfilePropertyText("adresse", e.target.value, 100, true) } errors={ errors.adresse }/>
            <ProfileLabeledInput label={ texts.ville } value={ profile.ville } onChange={ e => onChangeProfilePropertyText("ville", e.target.value, 40, true) } errors={ errors.ville }/>
            <ProfileLabeledInput label={ texts.codePostal } value={ profile.codePostal } onChange={ e => onChangeProfilePropertyText("codePostal", e.target.value, 9, true) } errors={ errors.codePostal }/>
            <ProfileLabeledInput label={ texts.telephonePrincipal } value={ profile.telephone1 } onChange={ e => onChangeProfilePropertyText("telephone1", e.target.value, 13, true) } errors={ errors.telephone1 }/>
            {/* NOTE: Messines veut ce terme (téléphone principal) */ }
            <ProfileLabeledInput label={ texts.telephoneSecondaire } value={ profile.telephone2 } onChange={ e => onChangeProfilePropertyText("telephone2", e.target.value, 13, false) } errors={ errors.telephone2 }/>
            {/* NOTE: Messines veut ce terme (téléphone secondaire) */ }
            { authToken != null &&
                <ProfileLabeledInput label={ texts.email } value={ profile.email } onChange={ e => onChangeEmail(e.target.value) } errors={ errors.email }/>
            }
            <ProfileDateInput
                label={ texts.dateNaissance }
                profile={ profile }
                setProfileState={ setProfileState }
                error={ errors.dateNaissance }
                calIconDansChamp={ calIconDansChamp }
                showCalendrierDateNaissance={ showCalendrierDateNaissance }
                toggleCalendrierDateNaissance={ toggleCalendrierDateNaissance }
                onSelectDateNaissance={ onSelectDateNaissance }
                calendarDateNaissanceWrapperDivRef={ calendarDateNaissanceWrapperDivRef }
            />
            <ProfileLabeledInput label={ "PERMIS DE PÊCHE" } value={ profile.permisPeche } onChange={ e => onChangeProfilePropertyText("permisPeche", e.target.value, 100) } errors={ errors.permisPeche }/>
            <div className="profile-div">
                <div className="profile-div profile-label-wrapper">
                    <span className="profile-span">{ "TYPE DE PERMIS DE PÊCHE" }</span>
                </div>
                <div className="profile-div input-container">
                    <select value={ profile.typePermisPeche } onChange={ e => setProfileState({...profile, typePermisPeche: e.target.value}) } className="profile-input">
                        { typesPermisPeche.map(typesPermisPeche => (
                            <option key={ typesPermisPeche.id } value={ typesPermisPeche.id }>
                                { typesPermisPeche.descriptionFr }
                            </option>
                        )) }
                    </select>
                    { errors.typesPermisPeche && <span className="color-error profile-span">{ errors.typesPermisPeche }</span> }
                </div>
            </div>

            <ProfileLabeledInput label={ "PERMIS DE PETIT GIBIER" } value={ profile.permisPetitGibier } onChange={ e => onChangeProfilePropertyText("permisPetitGibier", e.target.value, 100) } errors={ errors.permisPetitGibier }/>
        </>
    );
}
